import useDelayedQuery from '@hooks/useDelayedQuery.js';
import { tiltify } from '@playlive/tiltify-lib';
import { isTestMode } from '@util/const.js';
import { fakeTiltifyCampaign } from '@data/example/index.js';

export const useTiltifyCampaigns = (config) => {
  const { data: campaigns, isFetching: campaignsLoading } = useDelayedQuery({
    queryKey: ['tiltify', config.tiltifyUserID, 'getCampaigns'],
    placeholderData: undefined,
    queryFn: async () => {
      if (isTestMode) {
        return [fakeTiltifyCampaign];
      }
      if (!config.tiltifyUserID || config.tiltifyUserID === 'null') return [];
      if (campaigns.length) return campaigns;
      tiltify.UseProxy();
      try {
        return await tiltify.GetUserAndTeamCampaigns(config.tiltifyUserID);
      } catch (err) {
        throw new Error(err.message);
      }
    },
  });

  return { campaigns, campaignsLoading };
};
